import React from 'react';
import PropTypes from 'prop-types';
import styles from './AnalyticsMetricBar.module.scss';

export default function AnalyticsMetricBar({ value, maximum, valueFormatter, label, tone, compact }) {
  const numericValue = Number.isFinite(Number(value)) ? Number(value) : 0;
  const numericMaximum = Math.max(Number(maximum) || 0, numericValue, 1);
  const width = Math.max(0, Math.min(100, (numericValue / numericMaximum) * 100));
  const displayValue = valueFormatter(numericValue);

  return (
    <span
      className={`${styles.metric} ${styles[tone] || ''} ${compact ? styles.compact : ''}`.trim()}
      role="img"
      aria-label={`${label}: ${displayValue}`}
    >
      <span className={styles.fill} style={{ width: `${width}%` }} aria-hidden="true" />
      <span className={styles.value}>{displayValue}</span>
    </span>
  );
}

AnalyticsMetricBar.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maximum: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  valueFormatter: PropTypes.func,
  label: PropTypes.string.isRequired,
  tone: PropTypes.oneOf([
    'searches',
    'clickRate',
    'zeroResults',
    'clickEvents',
    'productViews',
    'lostOpportunities',
  ]),
  compact: PropTypes.bool,
};

AnalyticsMetricBar.defaultProps = {
  value: 0,
  maximum: 1,
  valueFormatter: (value) => Number(value).toLocaleString(),
  tone: 'searches',
  compact: false,
};
